import RenderLayout from "./components/RenderLayout"

export default function CustomFormTemplate1() {
  console.log("CustomFormTemplate1")
  const ID_TEMPLATE = "custom_form_template_1"
  const ID_BLOCKS = ["default__custom__block_5", "form"]
  const listViewCols = [
    {
      header: "Date",
      field: "form_date",
      block: "form",
      type: "date",
    },
    {
      header: "Submitted By",
      field: "staff_full_name",
      block: "form",
      type: "staff",
    },
  ]
  return (
    <RenderLayout
      ID_TEMPLATE={ID_TEMPLATE}
      ID_BLOCKS={ID_BLOCKS}
      listViewCols={listViewCols}
    />
  )
}
